module.exports = __webpack_public_path__ + "media/images/partners/6_munich-613f9fff49fcaac99031b96e6f42b34d.png";